import FormattedMessage from 'I18n/components/FormattedMessage';
import { subCategoryToFeatureIdsMap } from './featureIdToSubCategoryMap';
import { featureSubCategories } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
export const buildBodyDataBySubCategory = (features, subscreen) => {
  const featuresBySubCategory = {};
  featureSubCategories.forEach(subCategory => {
    featuresBySubCategory[subCategory] = features.filter(feature => subCategoryToFeatureIdsMap[subCategory].includes(feature.featureId));
  });
  return {
    sharedData: {
      subscreen
    },
    sectionData: {
      Attract: {
        features: featuresBySubCategory['ATTRACT'] || [],
        LabelContent: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "featureTables.suiteStarter.subCategories.ATTRACT"
        }),
        apiNames: ['hubspot-free', 'crm-suite-starter-bundle']
      },
      Build: {
        features: featuresBySubCategory['BUILD'] || [],
        LabelContent: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "featureTables.suiteStarter.subCategories.BUILD"
        }),
        apiNames: ['hubspot-free', 'crm-suite-starter-bundle']
      },
      Control: {
        features: featuresBySubCategory['CONTROL'] || [],
        LabelContent: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "featureTables.suiteStarter.subCategories.CONTROL"
        }),
        apiNames: ['hubspot-free', 'crm-suite-starter-bundle']
      },
      Resolve: {
        features: featuresBySubCategory['RESOLVE'] || [],
        LabelContent: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "featureTables.suiteStarter.subCategories.RESOLVE"
        }),
        apiNames: ['hubspot-free', 'crm-suite-starter-bundle']
      },
      Connect: {
        features: featuresBySubCategory['CONNECT'] || [],
        LabelContent: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "featureTables.suiteStarter.subCategories.CONNECT"
        }),
        apiNames: ['hubspot-free', 'crm-suite-starter-bundle']
      },
      Organize: {
        features: featuresBySubCategory['ORGANIZE'] || [],
        LabelContent: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "featureTables.suiteStarter.subCategories.ORGANIZE"
        }),
        apiNames: ['hubspot-free', 'crm-suite-starter-bundle']
      }
    }
  };
};